import { render, staticRenderFns } from "./RecommendGoods.vue?vue&type=template&id=b869cc8e&scoped=true"
import script from "./RecommendGoods.vue?vue&type=script&lang=js"
export * from "./RecommendGoods.vue?vue&type=script&lang=js"
import style0 from "./RecommendGoods.vue?vue&type=style&index=0&id=b869cc8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b869cc8e",
  null
  
)

export default component.exports